import React from 'react';
import { Form } from 'react-bootstrap';

interface InputBoxNumberProps {
  label: string;
  name: string;
  tabIndex?: number;
  value: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  errorFeedback?: any;
  onChange?: any;
  onBlur?: any;
  setFieldValue: any;
  isValid?: any;
  isInvalid?: any;
}

const maskNumber = (value: string) => {
  // Remove all non-numeric characters except for the decimal point
  let onlyNums = value.replace(/[^0-9.]/g, '');

  return onlyNums;
};

export const InputBoxNumber: React.FC<InputBoxNumberProps> = ({
  label,
  name,
  type = 'text',
  tabIndex,
  placeholder,
  required = false,
  value,
  errorFeedback,
  onChange,
  setFieldValue,
  onBlur,
  isValid,
  isInvalid,
}) => {
  React.useEffect(() => {
    setFieldValue(name, value);
  }, [value, setFieldValue, name]);

  return (
    <Form.Group controlId={name} className="mb-3">
      <Form.Label>{label}</Form.Label>

      <Form.Control
        type="text" // to ensure consistent behavior across browsers
        inputMode="decimal" // add support for decimal input in mobile browsers
        name={name}
        placeholder={placeholder}
        required={required}
        value={value}
        tabIndex={tabIndex}
        onChange={(e) => {
          const maskedValue = maskNumber(e.target.value);
          setFieldValue(name, maskedValue);
          onChange(e);
        }}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          // Allow tab key to work normally
          if (e.key === 'Tab') {
            return;
          }
          // Allow only numbers, decimal point, and control keys
          if (!/[\d.]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
            e.preventDefault();
          }
          // Prevent multiple decimal points
          if (e.key === '.' && value.includes('.')) {
            e.preventDefault();
          }
        }}
        onBlur={onBlur}
        isValid={isValid}
        isInvalid={isInvalid}
      />
      <Form.Control.Feedback type="invalid">{errorFeedback}</Form.Control.Feedback>
    </Form.Group>
  );
};
